<template>
  <BaseFormulaireVolontaire
    typeFormulaire="creationCompte"
    titleForm="Création de votre compte"
  ></BaseFormulaireVolontaire>
</template>

<script>
import BaseForm from "@/components/base/BaseForm";
import BaseFormulaireVolontaire from "@/components/base/BaseFormulaireCompte";

export default {
  name: "creationCompte",
  components: { BaseFormulaireVolontaire },
  extends: BaseForm,
};
</script>
